var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m390 315v92l122 65v-222z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 120,
    r: 90
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 120,
    r: 90
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75 315h210v92h-210z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 240v242h360v-242zm315 45v152h-270v-152z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/Movie.0e20e9db77ea15ee25b29d0d29c71a75.svg";
export { ForwardRef as ReactComponent };